// AI Generated Test
import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PagePerformanceChartsService } from '@client/app/modules/page-performance/components/charts/page-performance-charts/page-performance-charts.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { DoughnutChart } from '@client/app/modules/charts/models/charts/doughnut';

@Component({
    selector: 'page-performance-score-doughnut-chart',
    template: `
        <div class="score-doughnut-container">
            <mon-chart-doughnut [labels]="labels" [data]="data" [options]="options" [colors]="colors"></mon-chart-doughnut>
        </div>
    `,
    standalone: false,
})
export class PagePerformanceScoreDoughnutChartComponent implements OnChanges {
    @Input() score: any;

    labels: any[] = [];
    data: any[] = [];
    options: any = {};
    colors: any[] = [];
    doughnutChart: any;

    constructor (
        private translateService: TranslateService,
        private pagePerformanceChartsService: PagePerformanceChartsService,
        private pipeService: PipeService,
    ) {}

    ngOnChanges (): void {
        this.doughnutChart = new DoughnutChart();
        this.score = this.score || 0;
        this.labels = [this.translateService.getString('Performance Score'), this.translateService.getString('Performance Errors')];
        this.data = [this.pipeService.get('monNumber')(this.score), this.pipeService.get('monNumber')(100 - this.score)];
        this.doughnutChart.setCutOutPercentage(80);
        this.doughnutChart.setCenterText(this.pipeService.get('monNumber')(this.score));
        this.doughnutChart.setPercentageFontSize(60);
        this.doughnutChart.setPercentageFontWeight(600);
        this.doughnutChart.setTooltipSettings({
            enabled: true,
        });
        this.doughnutChart.setTooltipCustom({});
        this.options = this.doughnutChart.options;
        this.colors = [this.pagePerformanceChartsService.getColorByScore(this.score, 'dark'), '#d2d1d1'];
    }
}
